import * as React from "react"
import {
  CircleHelp,
  Globe,
  Images,
  Inbox,
  LayoutDashboard,
  Mail,
  Palette,
  Settings,
  Users,
  Wine,
} from "lucide-react"
import { AdminFlash } from "@/components/admin/AdminFlash"
import { MainNav, type NavItemDef } from "@/components/MainNav"

/** The path without its query string or hash. */
function pathOf(url: string) {
  return url.split(/[?#]/)[0]
}

function section(prefix: string) {
  return (url: string) => {
    const path = pathOf(url)
    return path === prefix || path.startsWith(`${prefix}/`)
  }
}

// Duncan's admin (M7): what came in, the catalogue and the site's content,
// then the system. Grouped with hairlines (more than eight items).
const ADMIN_NAV_ITEMS: NavItemDef[] = [
  {
    href: "/admin/dashboard",
    icon: LayoutDashboard,
    label: "Dashboard",
    match: (url) => ["/admin", "/admin/dashboard"].includes(pathOf(url)),
  },
  { href: "/admin/enquiries", icon: Inbox, label: "Enquiries", match: section("/admin/enquiries") },
  { href: "/admin/wines", icon: Wine, label: "Wines", match: section("/admin/wines") },
  { href: "/admin/leads", icon: Mail, label: "Leads", match: section("/admin/leads") },
  {
    href: "/admin/gallery_items",
    icon: Images,
    label: "Gallery",
    match: section("/admin/gallery_items"),
    separatorBefore: true,
  },
  { href: "/admin/faqs", icon: CircleHelp, label: "FAQs", match: section("/admin/faqs") },
  {
    href: "/admin/settings",
    icon: Settings,
    label: "Settings",
    match: section("/admin/settings"),
    separatorBefore: true,
  },
  { href: "/admin/users", icon: Users, label: "Users", match: section("/admin/users") },
  { href: "/admin/design-system", icon: Palette, label: "Design System", match: section("/admin/design-system") },
  // The starter's "App Home", kept as the way back to the public site.
  { href: "/", icon: Globe, label: "View site", match: () => false },
]

export function AdminShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-page text-ink-body">
      <MainNav items={ADMIN_NAV_ITEMS} brandHref="/admin/dashboard" />
      {/* pt-16 below lg clears the fixed navigation button (top-right). */}
      <main className="min-w-0 flex-1 px-4 pb-16 pt-16 sm:px-10 lg:py-8">
        <div className="mx-auto max-w-4xl">
          <AdminFlash />
          {children}
        </div>
      </main>
    </div>
  )
}
